<template>
	<div class="life">
		<div class="header">
			<div class="container">
				<div class="flex">
					<a class="logo"><img src="../../image/zsdb_logo.png" class="logoImg" style="width:132px"></a>
					<div class="menu" id="nav">
						<ul>
							<li class="menulist"><a @click="gotoHome()" class="">首页</a></li>
							<li class="menulist"><a @click="gotoCampus()" class="">校园招聘</a></li>
							<li class="menulist"><a @click="gotoSociety()" class="">社会招聘</a></li>
							<li class="menulist"><a @click="gotoIntern()" class="">实习生招聘</a></li>
							<li class="menulist"><a @click="gotoAboutus()" class="on">关于我们</a></li>
						</ul>
					</div>
					<div class="user">
						<div v-show="islogin" class="isLogin" style="display: none;">
							<div @click="gotopersonal()" style="cursor: pointer;"><span>个人中心</span></div>
							<span class="divider">|</span>
							<div @click="exit()" style="cursor: pointer;"><span> 退出</span></div>
						</div>
						<div v-show="unlogin" class="unLogin" style="display: none;">
							<div @click="gotologin()" style="cursor: pointer;"><span>登录</span></div>
							<span class="divider">|</span>
							<div @click="gotoregister()" style="cursor: pointer;"><span>注册</span></div>
						</div>
					</div>
					<el-popover class="ewm" trigger="hover" placement="bottom">
						<img src="../../image/ewm.jpg" class="code">
						<img src="../../image/icoewm.png" slot="reference" class="ico">
					</el-popover>
				</div>
			</div>
		</div>
		<div class="pagesbanner"
			style="background: url(//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_bannergy.jpg) top center no-repeat;">
			<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_gydh01.png"
				class="dh wow  fadeInLeft" style="left: 0">
			<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_gydh02.png"
				class="dh wow  fadeInLeft" style="right: 0">
			<div class="text">
				<h3>关于我们</h3>
				<p>ABOUT US</p>
			</div>
		</div>
		<div class="pagesabout">
			<div class="container">
				<div class="flex">
					<div class="aboutleft">
						<div class="item">
							<a @click="gotoAboutus()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico1.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico1on.png"
										class="icoon"></span>
								公司介绍
							</a>
						</div>
						<div class="item">
							<a @click="gotoProject()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico2.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico2on.png"
										class="icoon"></span>
								典型工程
							</a>
						</div>
						<div class="item">
							<a @click="gotoCulture()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico3.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico3on.png"
										class="icoon"></span>
								人才培养
							</a>
						</div>
						<div class="item on">
							<a @click="gotoLife()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico4.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico4on.png"
										class="icoon"></span>
								园区生活
							</a>
						</div>
						<div class="item ">
							<a @click="gotoRecruit()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico5.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico5on.png"
										class="icoon"></span>
								招聘Q&A
							</a>
						</div>

					</div>
					<div class="aboutright">
						<div class="abouttitle">
							<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dd.png"
								class="ico">人才培养
						</div>
						<div class="dxgc">
							<div class="lunbo">
								<div class="swiper-container swiper-gongcheng">
									<div class="swiper-wrapper">
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_rcpy_1.png">
											<p>博士后答辩</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_rcpy_2.png">
											<p>匠人堂~</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_rcpy_3.png">
											<p>团队协作锻炼</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_rcpy_4.png">
											<p>西溪讲堂~</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_rcpy_5.png">
											<p>新员工成长特训营</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_rcpy_6.png">
											<p>新员工入职融合</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_rcpy_7.png">
											<p>一带一路国际人才孵化项目</p>
										</div>
									</div>
								</div>
								<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_zjt.png"
									class="swiper-gongcheng-prev">
								<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yjt.png"
									class="swiper-gongcheng-next">
							</div>
							<div class="text2">
								两年新员工成长期、双导师配置助力职场启航；打造多通道职业发展路径，提供广阔且公平的发展平台，另有聚焦理念更新与技术创新的西溪讲堂/匠人堂、灵活的在线学习、丰富的内部技术交流，致力形成卓越的终身学习机制。
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<backtop></backtop>
	</div>
</template>

<script>
	import backtop from "../../components/backtop.vue"
	import {
		loginstatus,
		Logout,
	} from '../../api/user.js'
	// @ is an alias to /src
	export default {
		components: {
			backtop,
		},
		data() {
			return {
				value1: '',
				islogin: false,
				unlogin: false,
			}
		},

		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					this.islogin = true;
					this.unlogin = false;
				} else if (res.code != 200) {
					this.islogin = false;
					this.unlogin = true;
				}
			})
		},

		methods: {
			exit() {
				Logout().then((res) => {
					location.reload()
				})
			},
			gotologin() {
				this.$router.push('/login')
			},
			gotoregister() {
				this.$router.push('/register')
			},
			gotoHome() {
				this.$router.push('/')
			},
			gotoAboutus() {
				this.$router.push('/aboutus/introduce')
			},
			gotoCampus() {
				this.$router.push('/campus')
			},
			gotoSociety() {
				this.$router.push('/society')
			},
			gotoIntern() {
				this.$router.push('/intern')
			},
			gotoProject() {
				this.$router.push('/aboutus/project')
			},
			gotoCulture() {
				this.$router.push('/aboutus/culture')
			},
			// gotoLife() {
			// 	this.$router.push('/aboutus/life')
			// },
			gotoRecruit() {
				this.$router.push('/aboutus/recruit')
			},
			gotopersonal() {
				this.$router.push('/personal/resume')
			},
		}
	}
</script>

<style scoped>
	@import url(../../assets/css/index.css);
</style>
